// extracted by mini-css-extract-plugin
export default {"dialog-wrapper":"PdfDialog_dialog-wrapper__dnXSz"};